
const DiscountCustomerBuysInput = {
  "name": "DiscountCustomerBuysInput",
  "kind": "INPUT_OBJECT",
  "inputFieldBaseTypes": {
    "value": "DiscountCustomerBuysValueInput",
    "items": "DiscountItemsInput"
  }
};
export default DiscountCustomerBuysInput;